import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const AssetsAndInsurance = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [realEstateProperties, setRealEstateProperties] = useState([{
    id: 1
  }]);
  const [lifeInsurancePolicies, setLifeInsurancePolicies] = useState([{
    id: 1
  }]);
  const addRealEstate = () => {
    const newId = realEstateProperties.length > 0 ? Math.max(...realEstateProperties.map(p => p.id)) + 1 : 1;
    setRealEstateProperties([...realEstateProperties, {
      id: newId
    }]);
  };
  const removeRealEstate = (id: number) => {
    setRealEstateProperties(realEstateProperties.filter(p => p.id !== id));
  };
  const addLifeInsurance = () => {
    const newId = lifeInsurancePolicies.length > 0 ? Math.max(...lifeInsurancePolicies.map(p => p.id)) + 1 : 1;
    setLifeInsurancePolicies([...lifeInsurancePolicies, {
      id: newId
    }]);
  };
  const removeLifeInsurance = (id: number) => {
    setLifeInsurancePolicies(lifeInsurancePolicies.filter(p => p.id !== id));
  };
  return <div className="space-y-8" data-id="element-217" data-mp="3flvecft01ro2">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-218" data-mp="3fmwsit5baua0">
        <p className="text-slate-700" data-id="element-219" data-mp="3kjwyz562pz1n">
          Please provide information about your assets and insurance policies.
        </p>
      </div>

      {/* Joint Ownership */}
      <div className="space-y-4" data-id="element-220" data-mp="g4dr6aqx5s35">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-221" data-mp="g7jcdewfg9tl">
          Joint Ownership
        </h3>

        <div data-id="element-222" data-mp="7cvbe0xvxeal">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-223" data-mp="7cbqqcguobsv">
            Do you have any assets (accounts, title to a property) that you are
            on with another person other than a spouse?
          </label>
          <p className="text-sm text-slate-600 mb-3" data-id="element-224" data-mp="zu7nn24kwvdp">
            Examples include being a joint account holder of a parent's bank
            account, or on title to a child's property for 1%. This includes if
            you have a child as a joint account holder on a bank account.
          </p>
          <div className="flex items-center space-x-4 mb-4" data-id="element-225" data-mp="zpxe5ru32hzz">
            <label className="inline-flex items-center" data-id="element-226" data-mp="usdz4ppka16z">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('jointOwnership.exists')} data-id="element-227" data-mp="urvxfdk4quro" />
              <span className="ml-2" data-id="element-228" data-mp="lxqzka6kwj2n">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-229" data-mp="h1iq9df2bk3e">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('jointOwnership.exists')} data-id="element-230" data-mp="c1waaw7unpqw" />
              <span className="ml-2" data-id="element-231" data-mp="30g28v4ibzpu">No</span>
            </label>
          </div>

          {watch('jointOwnership.exists') === 'true' && <div data-id="element-232" data-mp="2enrzc38qq7uy">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-233" data-mp="2eqe640nt4jc4">
                With whom and what assets?
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Please describe the joint ownership arrangements" {...register('jointOwnership.details')} data-id="element-234" data-mp="2nohquuqyxc2v" />
            </div>}
        </div>
      </div>

      {/* Registered Accounts */}
      <div className="space-y-4" data-id="element-235" data-mp="24xgr44i0xci9">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-236" data-mp="24wf4d2rnb1kp">
          Registered Accounts
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-237" data-mp="1ca42losayumb">
          <div className="p-4 bg-slate-50 rounded-md" data-id="element-238" data-mp="1c7qcluchc8lm">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-239" data-mp="1h85qqo4l5k4n">RRSP</label>
            <div className="space-y-3" data-id="element-240" data-mp="3ixlacxsesl8h">
              <div data-id="element-241" data-mp="3iymlf29fd7q7">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-242" data-mp="3iw0gzbhtz8c7">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-243" data-mp="3snmooxuympa7">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-244" data-mp="3sph98b2bkfdr">
                    <span className="text-slate-500" data-id="element-245" data-mp="3nvmvdo9eauml">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.rrsp.value')} data-id="element-246" data-mp="6fd9tvioa3yk" />
                </div>
              </div>
              <div data-id="element-247" data-mp="2h8hgjec27yj7">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-248" data-mp="2h7y2w9tfzwaz">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.rrsp.beneficiary')} data-id="element-249" data-mp="2cbha32bastrk" />
              </div>
            </div>
          </div>

          <div className="p-4 bg-slate-50 rounded-md" data-id="element-250" data-mp="mzkoeadcsg7s">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-251" data-mp="91e0nn24bwlu">RIF</label>
            <div className="space-y-3" data-id="element-252" data-mp="93h0szwzj64a">
              <div data-id="element-253" data-mp="e0h5p7i3m2tt">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-254" data-mp="e10d3ua4h8tl">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-255" data-mp="2iqy0zv84ds">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-256" data-mp="419iztph4vu1">
                    <span className="text-slate-500" data-id="element-257" data-mp="1ufifwkq4yaxq">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.rif.value')} data-id="element-258" data-mp="1ygkfj2nysp08" />
                </div>
              </div>
              <div data-id="element-259" data-mp="2yef5ms38y2zs">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-260" data-mp="2tdhlwb2l90w6">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.rif.beneficiary')} data-id="element-261" data-mp="3q2fi7xpzl6vg" />
              </div>
            </div>
          </div>

          <div className="p-4 bg-slate-50 rounded-md" data-id="element-262" data-mp="dmlpm4w13wai">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-263" data-mp="do6k5uicff8d">TFSA</label>
            <div className="space-y-3" data-id="element-264" data-mp="8tskvh0k8nyf">
              <div data-id="element-265" data-mp="g6i20kjy97j9">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-266" data-mp="g71lw6t5u5zx">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-267" data-mp="l64ozlpky259">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-268" data-mp="q4pfuuixz9h1">
                    <span className="text-slate-500" data-id="element-269" data-mp="u617t6pag6se">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.tfsa.value')} data-id="element-270" data-mp="u3y9lzdzf7cl" />
                </div>
              </div>
              <div data-id="element-271" data-mp="1dtqs6suwb4rl">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-272" data-mp="1dwcwmjmhp45l">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.tfsa.beneficiary')} data-id="element-273" data-mp="1muf67nkah54h" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* RESP */}
      <div className="space-y-4" data-id="element-274" data-mp="2d61gg6j0ceey">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-275" data-mp="2d2x2wijnk6bm">
          RESP (Registered Education Savings Plan)
        </h3>

        <div data-id="element-276" data-mp="1kh3yy5mmeln9">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-277" data-mp="1khnexgspmzyn">
            Do you have an RESP?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-278" data-mp="1z6jlf9f4c4x5">
            <label className="inline-flex items-center" data-id="element-279" data-mp="1ue8jy24qcb2h">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('resp.exists')} data-id="element-280" data-mp="1ucnqygy2d06q" />
              <span className="ml-2" data-id="element-281" data-mp="11o0acyo9eyzi">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-282" data-mp="3dbloh4vk83y6">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('resp.exists')} data-id="element-283" data-mp="3i4es1pfal68o" />
              <span className="ml-2" data-id="element-284" data-mp="38dk6yods8cot">No</span>
            </label>
          </div>

          {watch('resp.exists') === 'true' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-285" data-mp="3w4zb8mp4d42p">
              <div data-id="element-286" data-mp="4xwk1v9a6xsh">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-287" data-mp="4wbmrxvl10qx">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-288" data-mp="3n52ia8vp5j1u">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-289" data-mp="3r41so907680o">
                    <span className="text-slate-500" data-id="element-290" data-mp="2bnkwgoe2n43l">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('resp.value')} data-id="element-291" data-mp="2fp63ht3xco5v" />
                </div>
              </div>
              <div data-id="element-292" data-mp="2elxnhta6rdtt">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-293" data-mp="2ekctc4rs9wwh">
                  Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('resp.beneficiary')} data-id="element-294" data-mp="24oj69rgful0g" />
              </div>
            </div>}
        </div>
      </div>

      {/* Real Estate */}
      <div className="space-y-4" data-id="element-295" data-mp="3q12u38dftwip">
        <div className="flex justify-between items-center" data-id="element-296" data-mp="3q2xbwdtex8ik">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-297" data-mp="3u3pp1i5enxk4">
            Real Estate
          </h3>
          <button type="button" onClick={addRealEstate} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-298" data-mp="1ignka49ow8nv">
            <PlusIcon size={16} className="mr-1" data-id="element-299" data-mp="1s5xd5mccxvd1" />
            Add Property
          </button>
        </div>

        <div data-id="element-300" data-mp="1ndw4sbib8osa">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-301" data-mp="1ne5m7apahnmd">
            Do you own real estate?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-302" data-mp="2220ggviy401k">
            <label className="inline-flex items-center" data-id="element-303" data-mp="1x3p3wd19nbfn">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('assets.realEstate.exists')} data-id="element-304" data-mp="2b4jen2bsdohh" />
              <span className="ml-2" data-id="element-305" data-mp="gq8o8pfjmm9l">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-306" data-mp="gsl5f0dh8sll">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('assets.realEstate.exists')} data-id="element-307" data-mp="bsgz236a9e93" />
              <span className="ml-2" data-id="element-308" data-mp="2gtjd6smm7vfj">No</span>
            </label>
          </div>

          {watch('assets.realEstate.exists') === 'true' && <>
              {realEstateProperties.map((property, index) => <div key={property.id} className="p-4 bg-slate-50 rounded-md mb-4" data-id="element-309" data-mp="2prbu217zjb51" data-mpi={index}>
                  <div className="flex justify-between items-center mb-3" data-id="element-310" data-mp="2zr2mzygwdi30">
                    <h4 className="font-medium" data-id="element-311" data-mp="34icbuwumghdu">Property {index + 1}</h4>
                    {realEstateProperties.length > 1 && <button type="button" onClick={() => removeRealEstate(property.id)} className="text-red-500 hover:text-red-700" data-id="element-312" data-mp="39hoz3ipenqgy">
                        <TrashIcon size={16} data-id="element-313" data-mp="3iin1jwk73pxf" />
                      </button>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-314" data-mp="16snq1auqswo1">
                    <div className="md:col-span-2" data-id="element-315" data-mp="11u40z1kur4rg">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-316" data-mp="xtsjtyrp7mkq">
                        Address
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Full property address" {...register(`assets.realEstate.properties.${index}.address`)} data-id="element-317" data-mp="swjwljrp0scm" />
                    </div>
                    <div data-id="element-318" data-mp="298z0t1shmt0f">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-319" data-mp="29aadjr3wvb3o">
                        How is title held?
                      </label>
                      <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register(`assets.realEstate.properties.${index}.titleType`)} data-id="element-320" data-mp="24gnyjsa9yv4p">
                        <option value="" data-id="element-321" data-mp="1k0mkbfn3cdv0">Please select</option>
                        <option value="jointTenants" data-id="element-322" data-mp="1k38yvz8eftmq">Joint Tenants</option>
                        <option value="tenantsInCommon" data-id="element-323" data-mp="27rs8qj73kegx">
                          Tenants in Common
                        </option>
                        <option value="sole" data-id="element-324" data-mp="1y175ujke4ns7">Sole Ownership</option>
                      </select>
                    </div>

                    {/* Show co-owner details if Joint Tenants or Tenants in Common */}
                    {(watch(`assets.realEstate.properties.${index}.titleType`) === 'jointTenants' || watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon') && <div className="md:col-span-2" data-id="element-325" data-mp="30ub8jcy9p2bo">
                        <label className="block text-navy-800 font-medium mb-2" data-id="element-326" data-mp="30rp1rfj7aqui">
                          {watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon' ? 'Other owner(s) and percentage of ownership' : 'Other owner(s)'}
                        </label>
                        <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder={watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon' ? 'e.g., Jane Doe – 50%, John Doe – 50%' : 'e.g., Jane Doe (spouse)'} {...register(`assets.realEstate.properties.${index}.coOwnerDetails`)} data-id="element-327" data-mp="2hx0a1ukgmcxa" />
                      </div>}

                    <div data-id="element-328" data-mp="s3r4roh340xk">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-329" data-mp="3qnr426mr4uqi">
                        Approximate Value
                      </label>
                      <div className="relative" data-id="element-330" data-mp="3vn3lucyrnbm8">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-331" data-mp="4gizh6jnorvj">
                          <span className="text-slate-500" data-id="element-332" data-mp="9797krjgv8tx">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`assets.realEstate.properties.${index}.value`)} data-id="element-333" data-mp="37xhnfrq7x0fa" />
                      </div>
                    </div>
                    <div data-id="element-334" data-mp="2qfj8n57059qv">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-335" data-mp="2qe97g74urlg0">
                        Approximate Mortgage Owing
                      </label>
                      <div className="relative" data-id="element-336" data-mp="2hmz6vvveyp1t">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-337" data-mp="2hm7aiitzsnah">
                          <span className="text-slate-500" data-id="element-338" data-mp="2coe35mgydn8m">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`assets.realEstate.properties.${index}.mortgageOwing`)} data-id="element-339" data-mp="27qcm17337xzs" />
                      </div>
                    </div>
                  </div>
                </div>)}
            </>}
        </div>
      </div>

      {/* Pensions */}
      <div className="space-y-4" data-id="element-340" data-mp="3hnsw4jo4uhm6">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-341" data-mp="33trvtlhj8mjp">
          Pensions
        </h3>

        <div data-id="element-342" data-mp="38m33xbmffenc">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-343" data-mp="38mkzs756fquq">
            What pensions do you have?
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Company pension, Government pension" {...register('pensions.details')} data-id="element-344" data-mp="2tu123m0sqbko" />
        </div>

        <div data-id="element-345" data-mp="2oyvi4sqyf6z8">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-346" data-mp="268gto0c48a7a">
            Who is the beneficiary on the pension plan, if applicable?
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('pensions.beneficiary')} data-id="element-347" data-mp="21bi29pju6hcs" />
        </div>
      </div>

      {/* Life Insurance */}
      <div className="space-y-4" data-id="element-348" data-mp="2k8jarkclmzlh">
        <div className="flex justify-between items-center" data-id="element-349" data-mp="2k9b2ul6zmf70">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-350" data-mp="2xzwr6pf7nhca">
            Life Insurance
          </h3>
          <button type="button" onClick={addLifeInsurance} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-351" data-mp="2ty2u0r484vgv">
            <PlusIcon size={16} className="mr-1" data-id="element-352" data-mp="32z9dn9266mec" />
            Add Policy
          </button>
        </div>

        <div data-id="element-353" data-mp="3fh7t4yavdfkx">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-354" data-mp="3fgpphglvnz2z">
            Do you have life insurance?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-355" data-mp="3ai4lr77f2x9s">
            <label className="inline-flex items-center" data-id="element-356" data-mp="3pgghnbmyu1zw">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('insurance.life.exists')} data-id="element-357" data-mp="3pdub9fbt9sj9" />
              <span className="ml-2" data-id="element-358" data-mp="2rs6h712tvmaw">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-359" data-mp="2rtpzex81o7fb">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('insurance.life.exists')} data-id="element-360" data-mp="36hku2j5m4lv1" />
              <span className="ml-2" data-id="element-361" data-mp="2dzyqnr250rkn">No</span>
            </label>
          </div>

          {watch('insurance.life.exists') === 'true' && <>
              {lifeInsurancePolicies.map((policy, index) => <div key={policy.id} className="p-4 bg-slate-50 rounded-md mb-4" data-id="element-362" data-mp="oi1sbjh97b7i" data-mpi={index}>
                  <div className="flex justify-between items-center mb-3" data-id="element-363" data-mp="tc5wxw31r75f">
                    <h4 className="font-medium" data-id="element-364" data-mp="en9tkcbxqib5">Policy {index + 1}</h4>
                    {lifeInsurancePolicies.length > 1 && <button type="button" onClick={() => removeLifeInsurance(policy.id)} className="text-red-500 hover:text-red-700" data-id="element-365" data-mp="17a49qx1pyvit">
                        <TrashIcon size={16} data-id="element-366" data-mp="y8ea53xooq9y" />
                      </button>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-367" data-mp="129gchtmwdig5">
                    <div data-id="element-368" data-mp="3iyls8xjgvqk2">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-369" data-mp="3iy3q5ka4ii48">
                        Insurer
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Insurance company name" {...register(`insurance.life.policies.${index}.insurer`)} data-id="element-370" data-mp="1ti9rkog72990" />
                    </div>
                    <div data-id="element-371" data-mp="1atmno99r7px0">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-372" data-mp="1apyvpejyjbke">
                        Policy Owner
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of policy owner" {...register(`insurance.life.policies.${index}.owner`)} data-id="element-373" data-mp="10t2k2zyri9bm" />
                    </div>
                    <div data-id="element-374" data-mp="2yqm3hfwuqoyv">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-375" data-mp="2yp15fgbbwnw9">
                        Insured Person
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of insured" {...register(`insurance.life.policies.${index}.insured`)} data-id="element-376" data-mp="37i4g5gulamn7" />
                    </div>
                    <div data-id="element-377" data-mp="2oqv7f9sn81wo">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-378" data-mp="2oqbrfymjznla">
                        Beneficiary
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register(`insurance.life.policies.${index}.beneficiary`)} data-id="element-379" data-mp="41xgdlfap9jp" />
                    </div>
                    <div data-id="element-380" data-mp="1qzf321gzb17b">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-381" data-mp="1lz0tug3n5l7p">
                        Face Value
                      </label>
                      <div className="relative" data-id="element-382" data-mp="20v09qcwzspne">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-383" data-mp="1vx86wnut7j4f">
                          <span className="text-slate-500" data-id="element-384" data-mp="29od99xpkapig">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`insurance.life.policies.${index}.value`)} data-id="element-385" data-mp="25n9uzfn5x1jc" />
                      </div>
                    </div>
                  </div>
                </div>)}
            </>}
        </div>
      </div>

      {/* Foreign Assets */}
      <div className="space-y-4" data-id="element-386" data-mp="2t9vjxlbmohlu">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-387" data-mp="2t8u0asgjqmsi">
          Foreign Assets
        </h3>

        <div data-id="element-388" data-mp="2fh5m8jmqlo8w">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-389" data-mp="2k9go3s11fk43">
            Do you own assets in a different jurisdiction?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-390" data-mp="25m5azlp7js1v">
            <label className="inline-flex items-center" data-id="element-391" data-mp="2ajnm9iqp6jd1">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('foreignAssets.exists')} data-id="element-392" data-mp="2ak6yqjxkwfjo" />
              <span className="ml-2" data-id="element-393" data-mp="20nu67pdrs7qi">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-394" data-mp="73sfsni362su">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('foreignAssets.exists')} data-id="element-395" data-mp="2ck4tn13y9dk" />
              <span className="ml-2" data-id="element-396" data-mp="3ok0is514azez">No</span>
            </label>
          </div>

          {watch('foreignAssets.exists') === 'true' && <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-397" data-mp="q1cx99iitz3f">
              <div data-id="element-398" data-mp="l2iajwhfnqe1">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-399" data-mp="l3bbuhxmhnos">
                  Jurisdiction
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., United States, United Kingdom" {...register('foreignAssets.jurisdiction')} data-id="element-400" data-mp="g5rv9bdgcyto" />
              </div>
              <div data-id="element-401" data-mp="1cbbga0oub4u8">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-402" data-mp="1cbv1prdp8bd0">
                  Description of Asset
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Real estate, Bank account" {...register('foreignAssets.description')} data-id="element-403" data-mp="1laykeu8yeoqz" />
              </div>
              <div data-id="element-404" data-mp="1zyjmcku3ehxb">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-405" data-mp="1zy1jh5cxd5gf">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-406" data-mp="290kljn8vze1m">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-407" data-mp="28z9gzl7ma29g">
                    <span className="text-slate-500" data-id="element-408" data-mp="9ozvz2zgclsp">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('foreignAssets.value')} data-id="element-409" data-mp="enkw72epf5h5" />
                </div>
              </div>
            </div>}
        </div>
      </div>

      {/* Digital Assets */}
      <div className="space-y-4" data-id="element-410" data-mp="2lcvalqpfbgbb">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-411" data-mp="1xky2oap3h8fh">
          Digital Assets
        </h3>

        <div data-id="element-412" data-mp="1tknrmjmg3rtr">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-413" data-mp="1tl72xhhlbhyt">
            Please list any digital assets (cryptocurrency, online accounts with
            value, etc.)
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Bitcoin wallet, PayPal balance, domain names" {...register('assets.digital')} data-id="element-414" data-mp="22jj2i90fpq3e" />
        </div>
      </div>

      {/* Debts */}
      <div className="space-y-4" data-id="element-415" data-mp="14qrsevbrl7ka">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-416" data-mp="14rugkvhpcvwi">
          Debts
        </h3>

        <div data-id="element-417" data-mp="qskzzupl3zs0">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-418" data-mp="qsuvfxteez53">
            Please provide a complete list of your debts, including values
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="e.g., Credit card debt: $5,000, Line of credit: $10,000, Car loan: $15,000" {...register('debts.owed')} data-id="element-419" data-mp="1jfflmuy51572" />
        </div>

        <div data-id="element-420" data-mp="1en4lps3edjei">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-421" data-mp="1emmddx3gneq8">
            Do you have any debts owing to you (e.g., by a promissory note)?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-422" data-mp="2761q6c8xo7cb">
            <label className="inline-flex items-center" data-id="element-423" data-mp="395izhbb9mb7h">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('debts.owedToYou.exists')} data-id="element-424" data-mp="3950t3luw2glu" />
              <span className="ml-2" data-id="element-425" data-mp="3ixg94dmmkv43">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-426" data-mp="3mve1fpbozxbp">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('debts.owedToYou.exists')} data-id="element-427" data-mp="2q6ohltgi8un3" />
              <span className="ml-2" data-id="element-428" data-mp="2z6tp03lp7t19">No</span>
            </label>
          </div>

          {watch('debts.owedToYou.exists') === 'true' && <div data-id="element-429" data-mp="347hdoimgfxsb">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-430" data-mp="343tk5jh0fbdl">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe debts owed to you, including amounts and from whom" {...register('debts.owedToYou.details')} data-id="element-431" data-mp="jffitxzk0bp7" />
            </div>}
        </div>
      </div>

      {/* Gifts to Children */}
      <div className="space-y-4" data-id="element-432" data-mp="frpkhatfxvw7">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-433" data-mp="fqo72zoycxbb">
          Gifts to Children
        </h3>

        <div data-id="element-434" data-mp="5trvgl3rbv2j">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-435" data-mp="5t9rt3ermekl">
            Have you made any gifts to any child that you are expecting to be
            equalized amongst other children upon your death?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-436" data-mp="3t0lll8akn6hb">
            <label className="inline-flex items-center" data-id="element-437" data-mp="1v9iyct5rddfy">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('giftsToChildren.exists')} data-id="element-438" data-mp="1v751qfvfjt6a" />
              <span className="ml-2" data-id="element-439" data-mp="3ph381x6g8e3n">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-440" data-mp="3pio6hxvvwh6s">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('giftsToChildren.exists')} data-id="element-441" data-mp="3bq85f2mjmt8i" />
              <span className="ml-2" data-id="element-442" data-mp="7cji5ler0cdk">No</span>
            </label>
          </div>

          {watch('giftsToChildren.exists') === 'true' && <div data-id="element-443" data-mp="c8gxppi6tepa">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-444" data-mp="3ug6e9ky60qd7">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe the gifts made and to which children" {...register('giftsToChildren.details')} data-id="element-445" data-mp="393l4nyroa0c" />
            </div>}
        </div>
      </div>

      {/* Other Assets */}
      <div className="space-y-4" data-id="element-446" data-mp="2bggp1xa7090r">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-447" data-mp="2bjkwd3iyfkvn">
          Other Valuable Assets
        </h3>

        <div data-id="element-448" data-mp="2khok86hewtqm">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-449" data-mp="2khwtzpi8nixl">
            Please list any other valuable assets
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Vehicles, Art, Jewelry, Collections" {...register('assets.other')} data-id="element-450" data-mp="1wsvi1sa75pnk" />
        </div>
      </div>
    </div>;
};
export default AssetsAndInsurance;